import React from 'react';
import { SvgIconProps } from 'nike-ui/src/declaration';

type AddInCircleIconProps = Pick<SvgIconProps, 'width' | 'height' | 'fill' | 'stroke'>;

function AddInCircleIcon({ width, height, fill, stroke }: AddInCircleIconProps) {
    return (
        <svg
            className="add-in-circle-icon"
            fill="none"
            fillRule="evenodd"
            viewBox="0 0 24 24"
            width={width}
            height={height}
        >
            <circle className="circle" cx="12" cy="12" r="11.5" stroke={stroke} />
            <path
                className="add"
                fill={fill}
                d="M12 6a.5.5 0 0 1 .5.5v5h5a.5.5 0 1 1 0 1h-5v5a.5.5 0 1 1-1 0v-5h-5a.5.5 0 1 1 0-1h5v-5A.5.5 0 0 1 12 6z"
            />
        </svg>
    );
}

export default AddInCircleIcon;
